import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField } from "../components";

const ParentSiblingsTable = ({ idArray }) => {
  return (
    <table style={{ borderCollapse: "collapse", width: "100%" }} className="smallPadded">
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #000",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            Relationship
          </td>
          <td
            style={{
              border: "1px solid #000",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            Condition/Cause of Death
          </td>
          <td
            style={{
              border: "1px solid #000",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            Age at
            <br />
            Onset
          </td>
          <td
            style={{
              border: "1px solid #000",
              textAlign: "center",
              verticalAlign: "middle",
            }}
          >
            If Deceased,
            <br />
            Age at Death
          </td>
        </tr>
        {idArray.map(id => (
          <tr key={id}>
            <td style={{ border: "1px solid #000", textAlign: "center" }}>
              <Field
                name={`ParentsSiblings${id}Relationship`}
                type="text"
                component={renderField}
              />
            </td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}>
              <Field
                name={`ParentsSiblings${id}MedicalCondition`}
                type="text"
                component={renderField}
              />
            </td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}>
              <Field name={`ParentsSiblings${id}AgeOnset`} type="text" component={renderField} />
            </td>
            <td style={{ border: "1px solid #000", textAlign: "center" }}>
              <Field name={`ParentsSiblings${id}AgeAtDeath`} type="text" component={renderField} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

ParentSiblingsTable.propTypes = {
  idArray: PropTypes.arrayOf(PropTypes.number),
};

export default ParentSiblingsTable;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/ParentSiblingsTable.js